// SPDX-FileCopyrightText: 2026 Ben Richardson
// SPDX-License-Identifier: AGPL-3.0-or-later
//
// The recipient drawer.
//
// Deliberately NOT a route. There is no per-person URL and no per-person page,
// so this site can never outrank the official register for someone's own name.
// The drawer is reachable only from a search the visitor performed.

import { openOverlay } from './overlay';
import { loadCitation } from './data';
import { escapeHtml } from './format';
import type { Core, Record_ } from './types';

export function openRecordDrawer(rec: Record_, core: Core): void {
  const place = [rec.suburb, rec.state, rec.postcode].filter(Boolean).join(' ');
  const rows: [string, string][] = [
    ['Award', rec.award],
    ['Year', String(rec.year || '—')],
    ['Honours list', rec.list || 'Not part of a named list'],
    ['Location as gazetted', place || 'Not published'],
    ['Post-nominal', rec.postNominal || '—'],
  ];

  const body = document.createElement('div');
  body.innerHTML = `
    <table>
      <caption class="panel-sub" style="text-align:left;margin-bottom:.5rem">
        As published in the Australian honours register.
      </caption>
      <tbody>
        ${rows
          .map(
            ([k, v]) =>
              `<tr><th scope="row" style="width:11rem">${escapeHtml(k)}</th><td>${escapeHtml(v)}</td></tr>`,
          )
          .join('')}
      </tbody>
    </table>
    <h3>Citation</h3>
    <p class="citation-slot"><span class="skeleton" style="display:block;width:80%"></span></p>
    <p class="panel-sub">Some records — particularly long-service and campaign medals, and
    older entries — carry no citation in the register.</p>
    <p class="panel-sub">To correct or remove this entry, contact the Australian Honours and
    Awards Secretariat at <a href="mailto:honours@gg.gov.au">honours@gg.gov.au</a>.</p>
  `;

  openOverlay({ title: rec.name || 'Recipient', body, kind: 'drawer' });

  const slot = body.querySelector('.citation-slot')!;
  loadCitation(rec.id, core.citeBuckets)
    .then((cit) => {
      slot.textContent = cit ?? 'No citation is published for this award.';
      if (!cit) slot.classList.add('panel-sub');
    })
    .catch(() => {
      slot.textContent = 'The citation could not be loaded.';
      slot.classList.add('panel-sub');
    });
}
